// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d1fddcb7","513":"d6bdd6ef","787":"48a3adfe"}[chunkId] + ".chunk.js";
};